/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Stack } from "@mui/material";
import { areasOfLawOverviewStyle } from "@/src/components/Sections/Generic/AreasOfLawOverview/areasOfLawOverviewStyle";
import ChipLegalbird from "@/src/components/legalbird/ChipLegalbird/ChipLegalbird";
import AccordionGroupProvider, { useAccordionGroup } from "@/src/components/Accordion/AccordionGroupProvider";
import Container from "@/src/components/Container/Container";
import LogoName from "@/src/components/LogoName/LogoName";
import Section from "@/src/components/Section/Section";
import { areasOfLawAccordionContent } from "@/src/components/AreaOfLawAccordion/areasOfLawAccordionContent";
import LogoBird from "@/src/components/Logo/LogoBird";
import AreaOfLawAccordion from "@/src/components/AreaOfLawAccordion/AreaOfLawAccordion";
import { mergeSx } from "@/src/utils/mergeSx";
import { useId } from "react";

export default function AreasOfLawOverview() {
  return (
    <AccordionGroupProvider>
      <AreasOfLawOverviewInner />
    </AccordionGroupProvider>
  );
}

function AreasOfLawOverviewInner() {
  const accordionGroup = useAccordionGroup();
  const { activeAccordionId } = accordionGroup;
  const id = useId();

  return (
    <Section>
      <Container variant={"full"} showVerticalPadding={false}>
        <Stack spacing={4} sx={{ position: "relative" }}>
          <Stack sx={areasOfLawOverviewStyle.mainSection}>
            <LogoBird sx={areasOfLawOverviewStyle.backgroundImage} />
            <Stack sx={areasOfLawOverviewStyle.headline} spacing={3}>
              <ChipLegalbird label={"Rechtsbereiche"} sx={areasOfLawOverviewStyle.chip} />
              <LogoName sx={areasOfLawOverviewStyle.logo} aria-hidden="true" />
            </Stack>
          </Stack>
          <Stack spacing={1}>
            {areasOfLawAccordionContent.map((content, idx) => {
              const accordionId = id + idx;

              return (
                <AreaOfLawAccordion
                  key={content.title}
                  accordionId={accordionId}
                  {...content}
                  sx={mergeSx(
                    (theme) => ({
                      [theme.breakpoints.up("lg")]: {
                        ...areasOfLawOverviewStyle.tiles[idx],
                      },
                    }),
                    areasOfLawOverviewStyle.tile,
                    activeAccordionId === accordionId && areasOfLawOverviewStyle.tileActive,
                  )}
                  sxContent={areasOfLawOverviewStyle.tileContent}
                />
              );
            })}
          </Stack>
        </Stack>
      </Container>
    </Section>
  );
}
